<template>
  <div class="jps-top">
    <BaseContainer tag="section" inner-class="jps-top-main-image-container">
      <ClientOnly>
        <div class="jps-top-main-image">
          <div class="jps-top-main-image-bg">
            <!-- TODO BaseImageの機能が現行のj-imgと遜色なくなったらBaseImageに置き換え -->
            <img :src="imageURLs[zbgIndex]" :class="{ 'fade-enter-active': isFading }"
              @load="onImageLoad"
              @click.self="openImageModal()" />
          </div>
          <div class="jps-top-main-image-description">
            <h2 @click="openImageModal()">
              {{ ls(currentImageElement.title) }}
            </h2>
          </div>
          <div class="jps-top-main-image-search-container" @click.self="openImageModal()">
            <div class="jps-top-main-image-search">
              <header class="has-text-centered jps-service-logo">
                <h1>
                  <!-- TODO iconにも用意してあるので可能ならBaseIconの表示の方が良さそうにも見える。レイアウト崩れるので一旦BaseImageに置き換え。 -->
                  <BaseImage :src="getFullPath('assets/img/brand/logo-horizontal-4c-w.svg')" :alt="ls(dapLangGlobal.serviceName)" />
                </h1>
                <p class="has-text-weight-bold">
                  {{
                    lss(
                      "日本のデジタルアーカイブを探そう",
                      "Find digital archives in Japan"
                    )
                  }}
                </p>
              </header>
              <UiTopSearch />
            </div>
          </div>
          <div class="jps-top-main-image-ctrl">
            <BaseIcon name="mdi/arrow-left-drop-circle-outline" @click.stop="previous()" class="jps-zooming-bg-prev" :alt="ls(dapLangGlobal.slideShow.previous)" />
            <BaseIcon name="mdi/arrow-right-drop-circle-outline" @click.stop="next()" class="jps-zooming-bg-next" :alt="ls(dapLangGlobal.slideShow.next)" />
          </div>
          <CurationModal ref="curationModal" />
        </div>
      </ClientOnly>
    </BaseContainer>
    <BaseContainer
      tag="section"
      inner-class="jps-top-begginer jps-top-section-inner"
    >
      <h2 class="top-h2">
        <BaseIcon name="koicon/koicon-26" />
        {{ ls(begginer.title) }}
      </h2>

      <div class="jps-top-begginer-body">
        <div class="top-begginer-list">
          <BaseLink v-for="part in toListElements(begginer.parts)" :key="part.def.cpid"
            :to="linkParamToLink(part.internalLink, part.link)"
            class="list-block"
          >
            <UiImageSelection class="top-image" :image="part.image" />
            <span class="has-text-centered">{{ ls(part.title) }}</span>
          </BaseLink>
        </div>
        <div class="top-begginer-right">
          <BaseLink v-for="basic in toListElements(basics.parts)" :key="basic.def.cpid"
            :to="linkParamToLink(basic.internalLink, basic.link)"
            class="jps-round-button is-size-7-touch jps-expanded"
          >
            <BaseIcon :name="getBasicIcon(basic)" />
            {{ ls(basic.title) }}
          </BaseLink>
        </div>
      </div>
    </BaseContainer>

    <BaseContainer
      v-if="notification"
      tag="section"
      class="jps-top-notification"
      inner-class="jps-top-notification-inner jps-top-section-inner"
    >
      <h2 class="top-h2">
        <BaseIcon name="koicon/koicon-26" />
        {{ lss("お知らせ", "Announcements") }}
      </h2>
      <CurationPartsRenderer :parts="notification" />
    </BaseContainer>

    <BaseContainer
      tag="section"
      inner-class="jps-top-pickups jps-top-section-inner"
    >
      <ClientOnly>
        <div
          class="jps-top-pickups-inner"
          v-for="(pickup, index) in pickups"
          :key="pickup.cpid"
        >
          <h2 class="top-h2">
            <BaseIcon :name="autoKoicon(pickup.title.ja)" />
            {{ ls(pickup.title) }}
          </h2>

          <div class="jps-top-pickups-list">
            <BaseLink v-for="part in toListElements(pickup.parts)" :key="part.def.cpid"
              :to="linkParamToLink(part.internalLink, part.link)"
              class="jps-top-pickups-link"
              :class="{ 'is-large-pickup': index == 2 }"
            >
              <template v-if="part.image?.imgType">
                <div class="img-bg">
                  <UiImageSelection :image="part.image" />
                </div>
                <h3>{{ ls(part.title) }}</h3>
                <p v-if="index == 2">{{ ls(part.description) }}</p>
              </template>
              <template v-else>
                <span class="more-link">
                  {{ ls(part.title) }}
                  <BaseIcon name="mdi/chevron-right" />
                </span>
              </template>
            </BaseLink>
          </div>
        </div>
      </ClientOnly>
    </BaseContainer>

    <ClientOnly>
      <BaseContainer
        tag="section"
        class="jps-top-others"
        inner-class="jps-top-section-inner"
        v-for="other in others"
        :key="other.cpid"
      >
        <div
          class="jps-top-others-inner"
        >
          <h2 class="top-h2">
            <BaseIcon :name="autoKoicon(other.title.ja)" />
            {{ ls(other.title) }}
          </h2>
          <div class="jps-top-others-list">
            <BaseLink v-for="part in getOthersList(other.cpid)" :key="part.def.cpid"
              :to="linkParamToLink(part.internalLink, part.link)"
              class="jps-top-others-link"
            >
              <template v-if="part.image?.imgType">
                <div class="img-bg">
                  <UiImageSelection :image="part.image" />
                  <div class="img-shade" />
                  <h3>{{ ls(part.title) }}</h3>
                </div>
              </template>
              <template v-else>
                <span class="more-link">
                  {{ ls(part.title) }}
                  <BaseIcon name="mdi/chevron-right" />
                </span>
              </template>
            </BaseLink>
          </div>
          <div class="toggle-other-button" v-if="showToggleOthers(other.cpid)">
            <button class="jps-link-button" @click="toggleOthers(other.cpid)">
              {{ !isOthersOpen(other.cpid) ? ls(dapLangGlobal.more) : ls(dapLangGlobal.hide) }}
              <BaseIcon :name="isOthersOpen(other.cpid) ? 'mdi/chevron-up' : 'mdi/chevron-down'" />
            </button>
          </div>
        </div>
      </BaseContainer>
    </ClientOnly>

    <div
      class="jps-top-bg-group"
    >
      <BaseContainer
        tag="section"
        inner-class="jps-top-notification-inner jps-top-bg-group-section"
      >
        <h2 class="top-h2">
          <BaseIcon name="koicon/koicon-26" />
          {{ lss("新着情報", "News") }}
        </h2>
        <div class="is-size-7" v-if="news">
          <p>
            <BaseLink :to="news.path">{{ ldate(news.date) }} {{ ls(news.title) }}</BaseLink>
          </p>
        </div>
      </BaseContainer>

      <BaseContainer
        tag="section"
        inner-class="jps-top-bg-group-section"
      >
        <p class="jps-top-status-panel is-size-7" v-if="page">
          {{
            lsst(
              "ジャパンサーチは我が国の幅広い分野のデジタルアーカイブと連携し、多様なコンテンツをまとめて検索・閲覧・活用できるプラットフォームです。デジタルアーカイブ推進に関する検討会の方針のもと、さまざまな機関の協力により、国立国会図書館がシステムを運用しています。現在、{}のデータベースと連携し、{}件のデータを収録しています。",
              "Japan Search is a national platform for aggregating metadata of digital resources of various fields and operated by the National Diet Library, Japan, in cooperation with a variety of organizations in Japan under policies established by the Study Group for Promoting Digital Archiving.Japan Search is now linked to {} databases, and contains {} searchable contents.",
              num(Number(page.pageParams["dbCount"])),
              num(Number(page.pageParams["itemCount"]))
            )
          }}
        </p>
      </BaseContainer>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { CurationModal } from '#components'

definePageMeta({
  disableDefaultMargin: {
    bottom: true,
  },
  qsearch: true,
})

const { getPageAndCache, getPage } = usePage()
const { page, meta } = await getPageAndCache()
useHead(meta)

const { ls, lss, lsst, ldate, num } = useI18n()
const dataStore = useDataStore()
const { toListElement, toModalInfo } = useListElement()
const { contentImageUrl } = useContent()

const topPage = computed((): Curation => {
  return dataStore.curation("jps-top");
})

//////検索背景//////////
const zbgIndex: Ref<number> = ref(-1)
const images = computed((): CurationPartDefinition[] => {
  if (!topPage.value || topPage.value.parts.length <= 0) return [];
  let list = clone(topPage.value.parts[0].parts);
  zbgIndex.value = Math.floor(Math.random() * list.length);
  return list;
})

const imageListElements = computed((): ListElement[] => {
  return images.value.map((i) => toListElement(i));
})

const imageURLs = computed(() => {
  return images.value.map((i) => contentImageUrl(i.image?.contentId, i.image?.imageId))
})

const currentImageElement = computed(() => {
  if (zbgIndex.value == -1) return null;
  return imageListElements.value[zbgIndex.value];
})

const isFading: Ref<boolean> = ref(false)

const previous = () => {
  isFading.value = true;
  setTimeout(() => {
    if (zbgIndex.value > 0) {
      zbgIndex.value--
    } else {
      zbgIndex.value = imageListElements.value.length - 1;
    }
  }, 250); // フェードアウトの時間と一致させる
}

const next = () => {
  isFading.value = true;
  setTimeout(() => {
    if (zbgIndex.value < imageListElements.value.length - 1) {
      zbgIndex.value++;
    } else {
      zbgIndex.value = 0;
    }
  }, 250); // フェードアウトの時間と一致させる
}

const onImageLoad = () => {
  isFading.value = false;
}

const curationModal = ref<InstanceType<typeof CurationModal>>()
const openImageModal = async () => {
  try {
    await curationModal.value.openAwait({
      info: toModalInfo(imageListElements.value[zbgIndex.value])
    },
    {
      animation: 'slideY',
    })
  } catch (error) {}
}

//はじめてのジャパンサーチ
const begginer = computed((): PartList => {
  return topPage.value?.parts?.[1]?.parts?.[0] || {};
})

//基本メニュー
const basics = computed((): PartList => {
  return topPage.value?.parts?.[1]?.parts?.[1] || {};
})

const getBasicIcon = (part: PartListExternalLink) => {
  if (part.description?.ja === "about") {
    return "mdi/bank";
  } else if (part.description?.ja === "school") {
    return "mdi/school";
  } else {
    return "mdi/help-circle-outline";
  }
}

//お知らせ
const notification = computed((): any => {
  if (topPage.value?.parts?.[2]?.parts?.length > 0) {
    return clone(topPage.value?.parts?.[2]?.parts);
  }
  return null;
})

//Pickup
const pickups = computed((): PartList => {
  return topPage.value?.parts?.[3]?.parts || [];
})

//その他
const others = computed((): PartList => {
  return topPage.value?.parts?.[4]?.parts || [];
})

const othersOpen = ref({})
const toggleOthers = (id: string) => {
  othersOpen.value[id] = !othersOpen.value[id]
}

const isOthersOpen = (id: string) => {
  return othersOpen.value[id]
}

const getOthersList = (id: string) => {
  const list = others.value.filter((def) => def.cpid === id).pop()?.parts || [];
  if (othersOpen.value[id]) {
    return toListElements(list);
  } else {
    return toListElements(list.slice(0, 3));
  }
}

const showToggleOthers = (id: string) => {
  const list = others.value.filter((def) => def.cpid === id).pop()?.parts || [];
  return list.length > 3;
}

const toListElements = (parts: CurationPartDefinition): ListElement[] => {
  return parts.map((p) => toListElement(p))
}

//News
const news = computed((): Page => {
  if (page?.pageParams['news']) {
    const newsPath = page.pageParams['news'].split(',')
    if (newsPath) {
      return dataStore.get('page', newsPath[0])
    }
  }
  return null
})
</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

.jps-top {
  display: flex;
  flex-direction: column;

  .jps-top-section-inner {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-top: 1rem;
    padding-bottom: 1rem;

    @include is-tablet {
      padding-top: 1.8rem;
      padding-bottom: 1.8rem;
    }
  }

  .jps-top-bg-group {
    background-color: $jps-gray-50;
    padding-top: 1.8rem;
    padding-bottom: 1.8rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @include is-tablet {
      gap: 1.8rem;
    }

    .jps-top-bg-group-section {
      display: flex;
      flex-direction: column;
      gap: 0.8rem;
    }
  }

  .top-h2 {
    .ui-base-icon {
      margin-right: 0.5rem;
      width: 1.25rem;
      height: 1.25rem;
      vertical-align: middle;
    }

    display: inline-block;
    vertical-align: middle;
    font-size: 1.25rem;
    font-weight: bold;
    margin: 0;
  }

  .top-image {
    border-radius: 16px;
    overflow: hidden;
    @include is-mobile {
      max-height: initial;
      aspect-ratio: 2 / 1;
      height: auto;
    }
    @include is-tablet {
      max-height: 111px;
      aspect-ratio: 2 / 1;
    }
  }

  .jps-top-main-image-container {
    @include is-mobile {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .jps-top-main-image {
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    @include is-mobile {
      border-radius: 0;
      margin-top: 0;
    }
    @include is-desktop {
      height: 540px;
    }

    .jps-top-main-image-bg {
      position: relative;
      overflow: hidden;
      @include is-mobile {
        height: 240px;
      }
      .fade-enter-active {
        opacity: 0;
        transition: opacity 1s ease-in-out;
      }

      img {
        width: 100%;
        object-fit: cover;

        @include is-mobile {
          min-height: 240px;
        }
        @include is-desktop {
          min-height: 540px;
        }
        display: block;
        cursor: pointer;
      }
    }

    .jps-top-main-image-description {
      position: absolute;
      left: 0px;
      top: 0px;
      padding: 8px 12px;
      border-bottom-right-radius: 0.75rem;
      background: rgba(0, 0, 0, 0.25);

      h2 {
        margin: 0;
        color: $white;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        font-size: 0.875rem;
      }
    }

    .jps-top-main-image-search-container {
      @include is-desktop {
        position: absolute;
        right: 0;
        bottom: 0;
      }
      width: 100%;
      display: flex;
      justify-content: center;
      cursor: pointer;

      .jps-top-main-image-search {
        cursor: default;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        background: rgba(0, 0, 0, 0.75);

        @include is-mobile() {
          max-width: 100%;
          padding: 1rem 2rem;

          h3 {
            margin-bottom: 1rem;
          }
        }

        @include is-desktop {
          width: 100%;
          max-width: 60%;
          padding: 2rem 2rem 0.5rem 2rem;
        }

        .jps-service-logo {
          h1 {
            img {
              width: 28rem;

              @include is-mobile() {
                width: 18rem;
              }
            }

            margin-bottom: 0;
          }

          p {
            color: $white;
            font-size: $size-8;
            margin-top: $size-8 * -1;

            @include is-mobile {
              padding-left: $size-8 * 2.5;
            }

            @include is-desktop {
              font-size: $size-6;
              margin-top: -1rem;
            }
          }
        }
        @include is-mobile {
          width: 100%;
          border-radius: 0;
        }

        .top-search {
          @include is-mobile {
            padding: 1rem 0 1rem 0;
          }
          @include is-desktop {
            padding: 1.5rem 2rem 1rem 2rem;
          }
        }
      }
    }

    .jps-top-main-image-ctrl {
      position: absolute;
      right: 0;
      bottom: 0;
      display: flex;
      padding: 0 0 0 0.5rem;
      background: rgba(0, 0, 0, 0.5);
      border-top-left-radius: 0.75rem;

      .jps-zooming-bg-prev,
      .jps-zooming-bg-next {
        color: $white;
        cursor: pointer;
        font-size: 1.5rem;
      }
    }
  }

  .jps-top-begginer {
    .jps-top-begginer-body {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      @include is-tablet {
        flex-direction: row;
      }
    }

    .top-begginer-list {
      display: grid;
      gap: 1.2rem 0.8rem;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      flex-grow: 1;

      @include is-tablet {
        grid-template-columns: repeat(3, 1fr);
      }

      @include is-desktop {
        grid-template-columns: repeat(4, 1fr);
      }

      .list-block {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        align-items: center;
        color: $black;
        font-weight: bold;
        font-size: 0.875rem;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }

        .jps-image-selection-2 {
          width: 100%;
          height: calc(100%/3*2);
        }
      }
    }
    .top-begginer-right {
      display: flex;
      flex-direction: column;
      gap: 12px;
      height: fit-content;
      flex-shrink: 0;
      min-width: 13rem;

      @include is-mobile {
        padding-top: 0;
        flex-direction: column;
      }
      .jps-round-button {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 4px;
        background-color: #f3f3e9;
        font-weight: bold;
        color: $black;
        border: 1px solid $border-grey;
        height: 3rem;

        &:hover {
          background-color: $jps-gray-800;
          color: $text-white;
        }

        .j-icon {
          font-size: 0.5rem;
        }
      }
    }
  }

  .jps-top-notification {
    background-color: $jps-gray-50;

    .jps-top-notification-inner {
      .curation-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem 1rem;

        @include is-desktop {
          flex-direction: row;
          gap: 1.5rem 1rem;
        }

        .jps-curation-text {
          flex-grow: 1;

          @include is-mobile {
            padding: 0;
            margin: 0;
          }
        }
        .jps-curation-image {
          max-width: 400px;

          @include is-mobile {
            padding: 0;
            margin: 0;
          }
          @include is-desktop {
            flex: 0 0 400px;
            max-width: initial;
          }

          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
    .jps-icon {
      color: $jps-key-yellow;
    }
  }

  .jps-top-pickups {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    @include is-tablet {
      gap: 4rem;
      grid-template-columns: 2fr 2fr 3fr;
    }

    .jps-top-pickups-inner {
      border-top: 3px solid black;
      padding-top: 0.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      &:nth-child(3) {
        @include is-mobile {
          grid-column: 1 / 3;
          grid-row: 2 / 3;
        }
      }
    }

    .jps-top-pickups-list {
      display: flex;
      flex-direction: column;
      gap: 1.2rem 0.8rem;

      .jps-top-pickups-link {
        display: flex;
        flex-direction: column;
        gap: 3px;
        align-items: center;

        &.is-large-pickup {
          align-items: flex-start;
        }

        &:hover {
          text-decoration: underline;
        }
      }

      .more-link {
        display: flex;
        align-items: center;
        align-self: flex-end;
      }

      .img-bg {
        width: 100%;
        overflow: hidden;
        background-color: #f3f3e9;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-height: 250px;

        .jps-image-selection-2 {
          max-height: 250px;
          width: 100%;
        }
      }

      h3 {
        margin: 0;
        font-size: 1rem;
      }

      p {
        font-size: 0.75rem;
      }
    }
  }

  .jps-top-others {
    .jps-top-others-inner {
      border-top: 3px solid black;
      padding-top: 0.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .jps-top-others-list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1.2rem 0.8rem;

        @include is-tablet {
          grid-template-columns: repeat(3, 1fr);
        }

        .jps-top-others-link {
          display: flex;
          flex-direction: column;
          gap: 3px;
          align-items: center;
          background: $jps-gray-600;
          border-radius: 16px;

          &.is-large-pickup {
            align-items: flex-start;
          }

          .more-link {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            color: $white;
            font-weight: bold;
            padding-left: 1rem;
          }

          .img-bg {
            position: relative;
            width: 100%;
            overflow: hidden;
            background-color: #f3f3e9;
            border-radius: 16px;
            height: 120px;

            .jps-image-selection-2 {
              height: 120px;
              min-width: 100%;
              background: $jps-gray-600;
              img {
                object-fit: cover;
                min-height: 120px;
                min-width: 100%;
              }
            }

            .img-shade {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              background: linear-gradient(180deg,
              rgba(0, 0, 0, 0.5) 0%,
              rgba(0, 0, 0, 0) 100%);
              border-radius: 16px;
            }

            h3 {
              margin: 0;
              font-size: 1rem;
              position: absolute;
              max-width: 85%;
              left: 0.75rem;
              top: 0.75rem;
              color: $white;
            }
          }
        }
      }

      .toggle-other-button {
        display: flex;
        justify-content: center;

        button {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }
  }

  .jps-top-status-panel {
    border-radius: $global-radius;
    border: 1px solid $jps-gray-300;
    background: $white;
    padding: 0.75rem;
    text-align: left;
  }
}
</style>
